<template>
	<div class="container_yf">

		<img src="@/assets/imgs/screen/pic_bg1.jpg" alt="" class="bg_yf">
		<div class="header_yf">
			<div class="logo_yf">
				<!-- <img src="@/assets/imgs/screen/pic_logo.png" alt="" class="logo">
				<span>天津港焦炭码头</span> -->
			</div>
			<div class="header_wrap_yf">
				<router-link to="/largescreen/index" class="header_menu_yf" active-class="header_menu_yf activ_home_yf">
					<img src="@/assets/imgs/screen/nav_btn_s.png" alt="" class="nav_btn">
					<img src="@/assets/imgs/screen/pic_btn_p.png" alt="" class="nav_btn1">
					<span>数据统计</span>
				</router-link>
				<router-link to="/largescreen/data" class="header_menu_yf" active-class="header_menu_yf activ_home_yf">
					<img src="@/assets/imgs/screen/nav_btn_s.png" alt="" class="nav_btn">
					<img src="@/assets/imgs/screen/pic_btn_p.png" alt="" class="nav_btn1">
					<span>运输数据</span>
				</router-link>
				<img src="@/assets/imgs/screen/nav_pic_light.png" alt="" class="nav_pic_light">

				<router-link to="/largescreen/index" class="header_menu_yf1">
					<img src="@/assets/imgs/screen/nav_btn_menu_s1.png" alt="" class="nav_btn2">
					<span>新能源运输平台</span>
				</router-link>
				<router-link to="/largescreen/fence" class="header_menu_yf" active-class="header_menu_yf activ_home_yf">
					<img src="@/assets/imgs/screen/nav_btn_menu_s.png" alt="" class="nav_btn">
					<img src="@/assets/imgs/screen/nav_btn_menu_p.png" alt="" class="nav_btn1">
					<span>车辆实况</span>
				</router-link>
				<router-link to="/largescreen/energy" class="header_menu_yf" active-class="header_menu_yf activ_home_yf">
					<img src="@/assets/imgs/screen/nav_btn_menu_s.png" alt="" class="nav_btn">
					<img src="@/assets/imgs/screen/nav_btn_menu_p.png" class="nav_btn1">
					<span>节能环保</span>
				</router-link>
			</div>

			<div class="weather">
				<img :src="weatherImg" alt="" class="weather_img">
				<span>{{ lives.weather }}</span>
				<span>{{ lives.temperature }}℃</span>
			</div>　
			<div class="timer">
				<span>{{ time }}</span>
			</div>
		</div>
		<div class="line_box">
			<img src="@/assets/imgs/screen/nav_pic_left.png" alt="">
			<img src="@/assets/imgs/screen/nav_block_left.png" alt="" class="nav_block_left">
			<img src="@/assets/imgs/screen/nav_block_right.png" alt="" class="nav_block_right">
			<img src="@/assets/imgs/screen/nav_pic_right.png" alt="">
			<img src="@/assets/imgs/screen/nav_flash_left.png" alt="" class="nav_flash_left1">
			<img src="@/assets/imgs/screen/nav_flash_left.png" alt="" class="nav_flash_left2">
			<img src="@/assets/imgs/screen/nav_pic_put1.png" alt="" class="nav_pic_put1">
			<img src="@/assets/imgs/screen/nav_pic_put1.png" alt="" class="nav_pic_put2">
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
			time: '',
			lives: {},
			currentpage: 1,
			weatherImg: require('@/assets/imgs/screen/weather1.png'),
		};
	},
	components: {

	},
	computed: {

	},
	watch: {

	},
	created() {

	},
	mounted() {


		this.resizeWindow();
		this.getNowTime();
		window.removeEventListener("resize", this.resizeWindow);
		this.getWeather("120116");

		var that = this;
		setInterval(function () {
			that.getWeather("120116");
		}, 1200000)
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.resizeWindow);
	},


	methods: {
		getNowTime() {
			let speed = 1000
			let that = this
			let theNowTime = function () {
				that.time = that.timeNumber()
			}
			setInterval(theNowTime, speed)
		},
		timeNumber() {

			let dt = new Date(),
				hour = (dt.getHours() + '').padStart(2, 0),
				min = (dt.getMinutes() + '').padStart(2, 0);
			return hour + ':' + min

		},
		getWeather(city) {
			if (!city) {
				city = "120116"
			}
			var that = this;
			axios({
				method: 'get',
				url: "https://restapi.amap.com/v3/weather/weatherInfo?key=a03996cfbfb168621ad6a266e08b74e7&&city=" + city + "&&extensions=base"
			}).then(
				(res) => {
					that.lives = res.data.lives[0];
					that.weatherImg = require('@/assets/imgs/screen/' + that.lives.weather + '.png')
				},
				(err) => {
					console.log(err);
				},
			)
		},


		resizeWindow() {
			let rootWidth = document.documentElement.clientWidth;
			let rootHeight = document.documentElement.clientHeight;
			let scaleRate = (rootWidth / 1920).toFixed(3) * 1;
			// console.log(1920 * scaleRate, 1080 * scaleRate);

			let targetDom = document.getElementsByClassName("container_yf")[0];
			// 当按照scale进行高度缩放时，缩放高度大于实际窗口高度，此时按照实际高度进行缩放
			if (1080 * scaleRate > rootHeight) {
				scaleRate = (rootHeight / 1080).toFixed(3) * 1;
				// console.log(1920 * scaleRate, 1080 * scaleRate, scaleRate);
				targetDom.style.width = `${rootWidth / scaleRate}px`;
			}
			else {
				targetDom.style.width = '1920px'
			}
			targetDom.style.transform = `scale(${scaleRate})`;

		},
	},
}

</script>

<style lang="scss">
ul,
li {
	list-style: none;
}

* {
	margin: 0;
	padding: 0;
}

.container_yf {
	width: 1920px;
	height: 1080px;
	overflow: hidden;
	position: relative;
	transform-origin: 0 0;
}

img {
	max-width: 100%;
}

.header_yf {
	display: flex;
	position: relative;
	z-index: 9999;

	.logo_yf {
		flex-shrink: 0;
		width: 180px;
		height: 33px;
		margin: 18px 47px 0 33px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #fff;
		font-weight: 700;
		
	}

	.header_wrap_yf {
		display: flex;

		.header_menu_yf {
			position: relative;
			margin-left: -14px;

			span {
				color: #fff;
				position: absolute;
				width: 100%;
				text-align: center;
				top: 0;
				left: 0;
				line-height: 62px;
				font-size: 22px;
				font-weight: bold;
			}
		}

		.header_menu_yf1 {
			position: relative;
			margin-left: -14px;
			width: 788px;

			span {
				color: #fff;
				position: absolute;
				width: 100%;
				text-align: center;
				top: 0;
				left: 0;
				line-height: 72px;
				font-size: 38px;
				font-family: Source Han Sans CN;
				z-index: 99999;
				font-weight: bold;
				color: #FFFFFF;
				text-shadow: -3px 3px 2px rgba(5, 25, 32, 0.28);
			}
		}
	}
}

.bg_yf {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0
}

.nav_btn,
.nav_btn1 {
	width: 173px;
	display: none;
}

.nav_btn {
	display: block;
}

.activ_home_yf {
	.nav_btn1 {
		display: block;
	}

	.nav_btn {
		display: none;
	}
}

.weather {
	display: flex;
	justify-content: center;
}

.weather_img {
	width: 51px;
	height: 52px;
	flex-shrink: 0;
	margin: 6px 0 0 6px;
}

.timer,
.weather span {
	color: #fff;
	font-size: 16px;
	line-height: 62px;
	margin-left: 14px;
}

.line_box {
	position: relative;
	display: flex;
	margin-top: -22px;
	z-index: 9999;

	.nav_flash_left1 {
		position: absolute;
		left: 40px;
		top: 6px
	}

	.nav_flash_left2 {
		position: absolute;
		right: 40px;
		top: 6px
	}

	.nav_pic_put1 {
		position: absolute;
		left: 710px;
		top: 6px
	}

	.nav_pic_put2 {
		position: absolute;
		left: 1120px;
		top: 6px
	}

	.nav_block_left {
		width: 75px;
		height: 6px;
		flex-shrink: 0;
		margin-left: 8px;
		margin-top: 8px;
	}

	.nav_block_right {
		width: 75px;
		height: 6px;
		flex-shrink: 0;
		margin-left: 612px;
		margin-top: 8px;
		margin-right: 8px;
	}
}

.nav_pic_light {
	position: absolute;
	left: 850px;
	top: 33px;
	z-index: 9;
}

@font-face {
	font-family: "stymixb";
	/* Project id  */
	src: url('~@/assets/imgs/screen/font/stymixb.ttf') format('truetype');
}

@keyframes bounce {

	0%,
	15%,
	47%,
	73%,
	89%,
	100% {
		animation-timing-function: ease-out;
		transform: translate3d(0, 0, 0);
	}

	30%,
	32% {
		animation-timing-function: ease-in;
		transform: translate3d(0, -21px, 0);
	}

	60% {
		animation-timing-function: ease-in;
		transform: translate3d(0, -10px, 0);
	}

	82% {
		animation-timing-function: ease-in;
		transform: translate3d(0, -5px, 0);
	}

	94% {
		animation-timing-function: ease-in;
		transform: translate3d(0, -2px, 0);
	}
}</style>